//
//
//
//
//
//
//
//

import {
    swiper,
    swiperSlide
} from 'vue-awesome-swiper'
import axios from 'axios'


export default {
    data() {
            return {
                bannerList: null,
                dataList: null,
                swiperOption: {
                    autoplay: 3000,
                    setWrapperSize: true,
                    pagination: '.swiper-pagination',
                    paginationClickable: true,
                    observeParents: true
                }
            }
        },
        mounted() {
            axios.get('https://bird.ioliu.cn/v1?url=http://m.kugou.com/?json=true')
                .then((response) => {
                    this.bannerList = response.data.banner;
                })
                .catch((error) => {
                    console.log(error);
                });
            //this.swiper.slideTo(4, 1000, false);
        }
}



// WEBPACK FOOTER //
// ./src/components/xbanner.vue